var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-button",
        {
          staticClass: "md-primary md-just-icon md-round",
          on: { click: _vm.showCreateIssueDialog },
        },
        [
          _c("md-icon", [_vm._v("add")]),
          _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
            _vm._v("Create issue"),
          ]),
        ],
        1
      ),
      _c(
        "md-dialog",
        {
          staticClass: "create-mobile-container",
          attrs: { "md-active": _vm.showDialog },
          on: {
            "update:mdActive": function ($event) {
              _vm.showDialog = $event
            },
            "update:md-active": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _c("md-dialog-title", [_vm._v("Create New Issue")]),
          _c("md-dialog-content", [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.createIssue($event)
                  },
                },
              },
              [
                _c("div", { staticClass: "md-layout" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Title")]),
                          _c("md-input", {
                            attrs: { required: "", maxlength: "100" },
                            model: {
                              value: _vm.issueForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.issueForm, "title", $$v)
                              },
                              expression: "issueForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Status")]),
                          _c(
                            "md-select",
                            {
                              attrs: { required: "" },
                              model: {
                                value: _vm.issueForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.issueForm, "status", $$v)
                                },
                                expression: "issueForm.status",
                              },
                            },
                            _vm._l(_vm.issueStatus, function (status, index) {
                              return _c(
                                "md-option",
                                {
                                  key: index,
                                  attrs: { value: status.issueStatusId },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(status.statusName) +
                                      "\n                                "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Related Entity Type")]),
                          _c(
                            "md-select",
                            {
                              attrs: { required: "" },
                              model: {
                                value: _vm.issueForm.relatedEntityType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.issueForm,
                                    "relatedEntityType",
                                    $$v
                                  )
                                },
                                expression: "issueForm.relatedEntityType",
                              },
                            },
                            [
                              _c("md-option", { attrs: { value: "Stop" } }, [
                                _vm._v("Stop"),
                              ]),
                              _c("md-option", { attrs: { value: "Trip" } }, [
                                _vm._v("Trip"),
                              ]),
                              _c(
                                "md-option",
                                { attrs: { value: "Shipment" } },
                                [_vm._v("Shipment")]
                              ),
                              !_vm.isTeamMember
                                ? _c(
                                    "md-option",
                                    { attrs: { value: "CustomerInvoice" } },
                                    [_vm._v("Customer Invoice")]
                                  )
                                : _vm._e(),
                              !_vm.isCustomerAdmin
                                ? _c(
                                    "md-option",
                                    { attrs: { value: "TeamMemberInvoice" } },
                                    [
                                      _vm._v(
                                        "\n                                    Team Member Invoice\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Related Entity Reference")]),
                          _c("md-input", {
                            attrs: { required: "" },
                            model: {
                              value: _vm.issueForm.relatedEntityRef,
                              callback: function ($$v) {
                                _vm.$set(_vm.issueForm, "relatedEntityRef", $$v)
                              },
                              expression: "issueForm.relatedEntityRef",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Initial Note")]),
                          _c("md-textarea", {
                            staticClass: "initial-note-textarea",
                            model: {
                              value: _vm.issueForm.initialNote,
                              callback: function ($$v) {
                                _vm.$set(_vm.issueForm, "initialNote", $$v)
                              },
                              expression: "issueForm.initialNote",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _c(
            "md-dialog-actions",
            { staticClass: "actions-custom" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-default",
                  on: {
                    click: function ($event) {
                      _vm.showDialog = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  attrs: { disabled: !_vm.isFormValid },
                  on: { click: _vm.createIssue },
                },
                [_vm._v("Create")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }